import React, {useCallback, useEffect, useRef, useState} from 'react';
import {microlessonsListText} from '../microlessonsListText';

interface Props {
  lessonId: string;
  onEditLesson: (id: string) => void;
  onPreviewLesson: (id: string) => void;
  onEditLessonInfo: (id: string) => void;
  onEditLessonVideo: (id: string) => void;
  onDelete: (id: string) => void;
}

const MicrolessonsOptions = React.memo(
  ({
    lessonId,
    onEditLesson,
    onPreviewLesson,
    onEditLessonInfo,
    // onEditLessonVideo,
    onDelete,
  }: Props) => {
    const [showOptions, setShowOptions] = useState(false);

    const openerRef = useRef<any>(null);
    const openerArrowRef = useRef<any>(null);

    useEffect(() => {
      window.addEventListener('click', handleBodyClick);
      return () => {
        window.removeEventListener('click', handleBodyClick);
      };
    }, [showOptions]);

    const handleBodyClick = useCallback(
      (ev: any) => {
        if (
          showOptions &&
          openerRef?.current !== ev.target &&
          openerArrowRef?.current !== ev.target
        ) {
          setShowOptions(false);
        }
      },
      [showOptions],
    );

    return (
      <div className="LessonOptions">
        <button
          className="Opener"
          onClick={() => setShowOptions(!showOptions)}
          ref={openerRef}>
          <span className="icon-dots-horizontal" ref={openerArrowRef}></span>
        </button>
        {showOptions && (
          <div className="Options">
            <div className={`Option`} onClick={() => onEditLesson(lessonId)}>
              {microlessonsListText.editLesson}
            </div>
            <div className={`Option`} onClick={() => onPreviewLesson(lessonId)}>
              {microlessonsListText.previewLesson}
            </div>
            {/* <div
              className={`Option`}
              onClick={() => onEditLessonVideo(lessonId)}>
              {microlessonsListText.editVideo}
            </div> */}
            <div
              className={`Option`}
              onClick={() => onEditLessonInfo(lessonId)}>
              {microlessonsListText.editInfo}
            </div>
            <div
              className={`Option DeleteOption`}
              onClick={() => onDelete(lessonId)}>
              {microlessonsListText.delete}
            </div>
          </div>
        )}
      </div>
    );
  },
);

export default MicrolessonsOptions;
